import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import Details from './details'
import Parteners from './parteners'
import CauseCards from './causeCards'
import causesData from 'testdata/causesData'

export default function CauseDetails(props) {
    const classes = useStyles()

    useEffect(() => {
    }, [])

    const id = props.match.params.id;
    const CauseData = causesData.length > 0 ? causesData.find(x => x.id == id) : {};

    return (
        <div className={classes.container}>
            <Details selectedCause={CauseData} id={id}/>
            <Parteners id={id}/>
            <CauseCards id={id}/>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
        minHeight: 400        
    }
}))